import React from 'react'
import { useHistory } from 'react-router-dom'
import routes from 'src/config/routes'
import { useCityTreatments } from '@hooks/useCityTreatments'
import { useCityVariantData } from '@hooks/useCityVariantData'
import { ManyClinicsTreatment } from './ManyClinicsTreatment'

export const CityTreatment = () => {
  const history = useHistory()
  const { data, isLoading } = useCityTreatments()
  const { treatmentBundleTypeReferenceId } = useCityVariantData()
  const goToNextPage = () => history.push(routes.clinic)

  return (
    <ManyClinicsTreatment
      categorizedAndUniqueTreatments={data}
      goToNextPage={goToNextPage}
      isLoading={isLoading}
      variantTreatmentBundleTypeReferenceId={treatmentBundleTypeReferenceId}
    />
  )
}
